import { render, staticRenderFns } from "./Keyboard65Mecha.vue?vue&type=template&id=5a655216&scoped=true&"
import script from "./Keyboard65Mecha.vue?vue&type=script&lang=js&"
export * from "./Keyboard65Mecha.vue?vue&type=script&lang=js&"
import style0 from "./Keyboard65Mecha.vue?vue&type=style&index=0&id=5a655216&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a655216",
  null
  
)

export default component.exports